import {LinkNode} from '@lexical/link';
import {TKNode} from '@tryghost/kg-default-nodes';

const MINIMAL_NODES = [
    LinkNode,
    TKNode
];

export default MINIMAL_NODES;
